export default "__VITE_ASSET__D8f2Xo6X__"